import React from 'react'
import moment from 'moment'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

const PlayerRow = props => {
  const formattedPhone = (player) => {
    const intlPhone = player.country_code && player.country_code.toLowerCase() != 'us'
    const result = intlPhone ? formatPhoneNumberIntl(player.phone) : formatPhoneNumber(player.phone)

    return intlPhone ? result.replaceAll(' ', '-') : result
  }

  return (
    <tr onClick={props.onClick}>
      <td>{props.player.first_name}</td>
      <td>{props.player.last_name}</td>
      <td>{formattedPhone(props.player)}</td>
      <td>{props.player.gender?.replaceAll('_', ' ')}</td>
      <td>{props.player.date_joined ? moment(props.player.date_joined).format('MM/DD/YYYY') : ''}</td>
      <td>{props.player.region_name}</td>
        {props.showTimesPlayed && <td>{parseInt(props.player.times_played)}</td>}
      <td>{props.player.banned && new DOMParser().parseFromString('&#9635', 'text/html').body.textContent}</td>
      <td>{props.player.opted_out && new DOMParser().parseFromString('&#9635', 'text/html').body.textContent}</td>
    </tr>
  )
}

export default PlayerRow
